import { type ReactNode } from 'react';
import { FieldInput } from '@/components/ui/field-input';
import type { ReplaceMode } from './ig-replace-modal';

type Props = {
  mode: ReplaceMode;
  currentPrimary: string;
  value: string;
  setValue: (v: string) => void;
  demote: boolean;
  setDemote: (v: boolean) => void;
  pending: boolean;
  canSubmit: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

const CANCEL_CLS =
  'rounded-md border border-border-subtle px-base py-sm text-sm text-text-secondary hover:bg-surface-elevated';
const CONFIRM_CLS =
  'rounded-md bg-brand-red px-base py-sm text-sm font-medium text-white hover:bg-brand-coral disabled:opacity-50';

type DemoteProps = {
  demote: boolean;
  setDemote: (v: boolean) => void;
  current: string;
};

function DemoteCheckbox({
  demote,
  setDemote,
  current,
}: DemoteProps): ReactNode {
  return (
    <label className="flex cursor-pointer items-start gap-sm text-xs text-text-secondary">
      <input
        type="checkbox"
        checked={demote}
        onChange={(e) => setDemote(e.target.checked)}
        className="mt-0.5"
      />
      <span>
        Mover el IG actual (<strong>@{current}</strong>) a secundario
      </span>
    </label>
  );
}

function Footer({
  pending,
  canSubmit,
  onCancel,
  onConfirm,
}: Pick<Props, 'pending' | 'canSubmit' | 'onCancel' | 'onConfirm'>): ReactNode {
  return (
    <div className="flex justify-end gap-sm">
      <button onClick={onCancel} className={CANCEL_CLS}>
        Cancelar
      </button>
      <button
        onClick={onConfirm}
        disabled={!canSubmit || pending}
        className={CONFIRM_CLS}
      >
        {pending ? 'Guardando...' : 'Confirmar'}
      </button>
    </div>
  );
}

export function IgReplaceBody(p: Props): ReactNode {
  const isPrimary = p.mode === 'replace_primary';
  return (
    <div className="space-y-base">
      <FieldInput
        autoFocus
        value={p.value}
        onChange={(e) => p.setValue(e.target.value)}
        placeholder="usuario_instagram"
      />
      {isPrimary && (
        <DemoteCheckbox
          demote={p.demote}
          setDemote={p.setDemote}
          current={p.currentPrimary}
        />
      )}
      <Footer {...p} />
    </div>
  );
}
